module.exports = __webpack_public_path__ + "static/media/3.a9658449.svg";